module.exports = __webpack_public_path__ + "assets/img/favicon/favicon-32x32.7f2ceea5f455347cabed962d790d6af9.png";